import * as types from './mutation-types'
import Vue from 'vue'

const state = {
  modalRequestComponent: {
    component: '',
    propData: {}
  }
}

const getters = {
  modalRequestComponentName: state => state.modalRequestComponent.component,
  modalRequestComponentPropData: state => state.modalRequestComponent.propData
}

const actions = {
  async [types.SET_MODAL_REQUEST_COMPONENT]({ commit }, payload) {
    commit(types.SET_MODAL_REQUEST_COMPONENT, payload)
  }
}

const mutations = {
  [types.SET_MODAL_REQUEST_COMPONENT](state, result) {
    Vue.set(state.modalRequestComponent, 'component', result.component)
    Vue.set(state.modalRequestComponent, 'propData', result.propData)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
